import "./style.scss";

const Loader = () => {
	return <span class="loader1"></span>;
};
export default Loader;
